import { BadgeProps, SvgExclamation } from '@grubhubprod/gh-cookbook-react';
import { formatPenniesToCurrency } from 'src/common/utils/formatPenniesToCurrency';
import { BalanceCreditLimitStatus } from 'src/components/selfService/common/Balance/utils/getBalanceCreditLimitStatus/getBalanceCreditLimitStatus';

export const getCreditProgressBadge = (
  creditProgressStatus: BalanceCreditLimitStatus,
  availableCreditInPennies: number
): BadgeProps => {
  switch (creditProgressStatus) {
    case BalanceCreditLimitStatus.OK:
      return {
        label: `Available: ${formatPenniesToCurrency(
          availableCreditInPennies
        )}`,
        flavor: {
          backgroundColor: 'tintCelebration',
          textColor: 'onTintCelebration',
        },
      };
    case BalanceCreditLimitStatus.LIMIT_APPROACHING:
      return {
        label: `Available: ${formatPenniesToCurrency(
          availableCreditInPennies
        )}`,
        rightIcon: SvgExclamation,
        flavor: {
          backgroundColor: 'tintEggYolk',
          textColor: 'globals.yellow70',
        },
      };

    case BalanceCreditLimitStatus.SUSPENDED:
    default:
      return {
        label: 'Account suspended',
        rightIcon: SvgExclamation,
        flavor: {
          backgroundColor: 'tintAlert',
          textColor: 'onTintAlert',
        },
      };
  }
};
